import { Help } from '@project-lary/react-material-symbols';
import PlusButton from 'gcs-common/components/PlusButton/PlusButton';
import FeatureFlagProtectedRoute from 'gcs-common/components/ProtectedRoutes/FeatureFlagProtectedRoute';
import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import FEATURE_FLAGS from 'gcs-common/helper/featureFlagsHelper';
import useNavigateWithQueryParams from 'gcs-common/hooks/useNavigateWithQueryParams';
import { getCurrentFriendlyName, getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { getIsOnline } from 'gcs-common/slices/offline/offlineSelectors';
import { getFavicon } from 'gcs-common/slices/theme/themeSelectors';
import { getSidebarCollapsed } from 'gcs-common/slices/uiState/uiStateSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import openHelp from '../../slices/settings/settingsThunks/openHelp';
import CurrentUserImage from '../CurrentUserImage/CurrentUserImage';
import styles from './styles.module.scss';

const NavBar = () => {
  const isAgent = useSelector(getIsAgent);
  const friendlyName = useSelector(getCurrentFriendlyName);
  const sidebarCollapsed = useSelector(getSidebarCollapsed);
  const logo = useSelector(getFavicon);
  const location = useLocation();
  const { pathname } = location;
  const showCreateTicket = pathname.startsWith(CHAT_ROUTES.TICKETS);
  const isOnline = useSelector(getIsOnline);
  const navigateWithQueryParams = useNavigateWithQueryParams();
  const dispatch = useDispatch();

  const onOpenHelp = () => {
    dispatch(openHelp());
  };

  const goToNewTicket = () => {
    navigateWithQueryParams(CHAT_ROUTES.NEW_TICKET, ['creatorIds']);
  };

  return (
    <div
      className={`${isAgent ? styles.userDetailsContainer : styles.craftsmanDetailsContainer} border-0 border-neutral-7 border-b border-solid`}
    >
      {sidebarCollapsed ? (
        <CurrentUserImage />
      ) : (
        <>
          {isAgent && <img src={logo} className={styles.agentLogoIcon} alt="Firmenlogo" />}
          <CurrentUserImage />
          <div className={`${isAgent ? styles.userDetails : styles.userCraftsmanDetails} w-full`}>
            <div className="flex w-full items-center justify-between">
              <div className="flex-1" data-testid="myusername">
                {friendlyName}
              </div>
              {!isAgent && showCreateTicket && (
                <div className="ml-auto">
                  <PlusButton onClick={goToNewTicket} iconSize="size-8" />
                </div>
              )}
            </div>
          </div>
          {isAgent && (
            <div className={styles.wrapper}>
              <FeatureFlagProtectedRoute disabledFlag={FEATURE_FLAGS.SUPPORT_PAGE_DISABLED}>
                <IconButton
                  Icon={Help}
                  iconSize="size-6"
                  className="cursor-pointer"
                  size="m"
                  variant="ghost_neutral"
                  disabled={!isOnline}
                  onClick={() => onOpenHelp()}
                />
              </FeatureFlagProtectedRoute>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default NavBar;
